module.exports = __webpack_public_path__ + "img/5.e8110a95.jpg";